import posthog from 'posthog-js';

/** True only in production builds that have `VITE_POSTHOG_KEY` set. Dev and test always disabled. */
export const ANALYTICS_ENABLED =
  import.meta.env.PROD &&
  import.meta.env.MODE === 'production' &&
  !!import.meta.env.VITE_POSTHOG_KEY;

/**
 * Client-side event names. Server-side events (`checkout_completed`, `subscription_past_due`,
 * `subscription_cancelled`) are plain strings in `supabase/functions/_shared/posthog.ts` —
 * they don't need client-side types since Deno doesn't import from this module.
 */
export type AnalyticsEvent =
  | 'landing_cta_clicked'
  | 'signup_started'
  | 'signup_completed'
  | 'email_confirmed'
  | 'onboarding_step_viewed'
  | 'onboarding_completed'
  | 'activation_first_client_created'
  | 'activation_first_os_created'
  | 'activation_first_team_invited'
  | 'feature_used'
  | 'os_completed'
  | 'plan_limit_hit_soft'
  | 'plan_limit_hit_hard'
  | 'upgrade_cta_viewed'
  | 'checkout_started'
  | 'agenda_viewed'
  | 'agenda_os_rescheduled';

let initialized = false;

/** Initialize the PostHog SDK. Idempotent; safe to call multiple times. No-op in dev/test. */
export function initAnalytics() {
  if (!ANALYTICS_ENABLED || initialized) return;
  const key = import.meta.env.VITE_POSTHOG_KEY!;
  const host = import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com';
  posthog.init(key, {
    api_host: host,
    persistence: 'localStorage',
    capture_pageview: true,
    autocapture: false,
    disable_session_recording: true,
  });
  initialized = true;
}

/** Returns the PostHog instance if initialized, otherwise null. Cheap to call on every render. */
export function getPosthog() {
  return ANALYTICS_ENABLED && initialized ? posthog : null;
}
